import fp from "lodash/fp"

import type { IceType } from "types/icing.types"

import { darkTheme } from "styles/themes"
import { ICE_ACCRETION_SEVERITY_FIELD } from "helpers/config/telemetryFieldDefs"

export const ICE_TYPES: IceType[] = [
  {
    severity: 5,
    color: darkTheme.palette.error.main,
    labelKey: "ice_types.GLAZE",
    shortLabelKey: "ice_types_short.GLAZE",
    descriptionKey: "plots_descriptions.ICING_DIALOG.GLAZE_DESC",
  },
  {
    severity: 4,
    color: darkTheme.palette.extras.orange.main,
    labelKey: "ice_types.GLAZE_AND_HARD_RIME",
    shortLabelKey: "ice_types_short.GLAZE_AND_HARD_RIME",
    descriptionKey: "plots_descriptions.ICING_DIALOG.GLAZE_AND_HARD_RIME_DESC",
  },
  {
    severity: 3,
    color: darkTheme.palette.warning.main,
    labelKey: "ice_types.HARD_RIME",
    shortLabelKey: "ice_types_short.HARD_RIME",
    descriptionKey: "plots_descriptions.ICING_DIALOG.HARD_RIME_DESC",
  },
  {
    severity: 2,
    color: darkTheme.palette.extras.skyBlue.main,
    labelKey: "ice_types.WET_SNOW_AND_GLAZE",
    shortLabelKey: "ice_types_short.WET_SNOW_AND_GLAZE",
    descriptionKey: "plots_descriptions.ICING_DIALOG.WET_SNOW_AND_GLAZE_DESC",
  },
  {
    severity: 1,
    color: darkTheme.palette.primary.main,
    labelKey: "ice_types.WET_SNOW",
    shortLabelKey: "ice_types_short.WET_SNOW",
    descriptionKey: "plots_descriptions.ICING_DIALOG.WET_SNOW_DESC",
  },
  {
    severity: 0,
    color: darkTheme.palette.secondary.main,
    labelKey: "ice_types.NO_ACCRETION",
    shortLabelKey: "ice_types_short.NO_ACCRETION",
    descriptionKey: "plots_descriptions.ICING_DIALOG.NO_ACCRETION_DESC",
  },
]

export const ICE_TYPES_BY_SEVERITY: Record<number, IceType> = fp.keyBy(
  "severity",
  ICE_TYPES,
)

export const ICE_TYPE_FIELD_PROPERTIES: Record<string, { color: string }> = fp.flow(
  fp.map((type: IceType) => [
    JSON.stringify({
      _field: ICE_ACCRETION_SEVERITY_FIELD,
      _value: type.severity,
    }),
    { color: type.color },
  ]),
  fp.fromPairs,
)(ICE_TYPES)
